import styled from 'styled-components';

export const ActionItem = styled.div`
  /* padding-top: 6px; */
  padding: 5px 8px 8px 8px;
  cursor: pointer;

  & > * {
    pointer-events: none;
  }

  &:hover {
    background: ${({ theme }) => theme.primaryColor};
    color: white;
    font-weight: 600;
  }
`;
